import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeBeforeFAQ() {
  return <section className="w-full bg-white py-12 md:py-16 pb-6 md:pb-8 px-4" data-id="element-181">
      <div className="max-w-2xl mx-auto" data-id="element-182">
        <div className="bg-white rounded-2xl p-8 md:p-10 border-2 border-green-300 shadow-lg" data-id="element-183">
          {/* Header with shield icon */}
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-184">
            <ShieldCheckIcon className="w-10 h-10 text-green-600" data-id="element-185" />
            <h2 className="text-3xl md:text-4xl font-black font-heading text-gray-900" data-id="element-186">
              Garantía 7 días sin preguntas
            </h2>
          </div>

          {/* 3 numbered steps */}
          <div className="space-y-3 mb-8 max-w-md mx-auto" data-id="element-187">
            <div className="flex items-center gap-3" data-id="element-188">
              <div className="bg-green-600 rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0" data-id="element-189">
                <span className="text-white font-bold text-lg" data-id="element-190">1</span>
              </div>
              <p className="text-gray-800 font-body text-base md:text-lg font-semibold" data-id="element-191">
                Abres los tomos
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-192">
              <div className="bg-green-600 rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0" data-id="element-193">
                <span className="text-white font-bold text-lg" data-id="element-194">2</span>
              </div>
              <p className="text-gray-800 font-body text-base md:text-lg font-semibold" data-id="element-195">
                Revisas los bonos
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-196">
              <div className="bg-green-600 rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0" data-id="element-197">
                <span className="text-white font-bold text-lg" data-id="element-198">3</span>
              </div>
              <p className="text-gray-800 font-body text-base md:text-lg font-semibold" data-id="element-199">
                Lo aplicas
              </p>
            </div>
          </div>

          {/* Guarantee message box */}
          <div className="bg-green-50 rounded-xl p-6 border-2 border-green-600" data-id="element-200">
            <p className="text-lg md:text-xl font-bold text-gray-900 font-heading mb-3 text-center" data-id="element-201">
              Si en 7 días no es lo que esperabas:
            </p>
            <p className="md:text-3xl text-green-700 font-heading mb-3 text-center text-[20px] font-[900]" data-id="element-202">
              👉 Te devolvemos el 100%
            </p>
            <div className="text-center" data-id="element-203">
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-204">
                Sin preguntas. Sin vueltas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}